module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/faq.component.html
// module id = ../../../../../src/app/home/faq.component.html
// module chunks = main